import React from 'react';
import ChatSidePanelPeopleList from './ChatSidePanelPeopleList';

export default function ChatSidePanelGroupedPeopleList({
  groups = [],
  unassignedLabel = '未設定',
  resolveGroupKey,
  resolveGroupLabel,
  resolvePeople,
  onSelect,
  resolveSelectPayload,
  resolveRowKey,
  resolveRowProps,
  wrapperClassName = 'side-part-subgroups',
  groupClassName = 'side-part-subgroup',
  titleClassName = 'side-part-subtitle',
  listClassName = 'side-list side-list--people',
}) {
  const safeGroups = Array.isArray(groups) ? groups : [];

  return (
    <div className={wrapperClassName}>
      {safeGroups.map((group, index) => {
        const groupKey =
          (typeof resolveGroupKey === 'function' ? resolveGroupKey(group, index) : null)
          || group?.key
          || group?.id
          || `group-${index}`;
        const label =
          (typeof resolveGroupLabel === 'function' ? resolveGroupLabel(group, index) : null)
          || group?.label
          || group?.title
          || unassignedLabel;
        const people =
          typeof resolvePeople === 'function'
            ? resolvePeople(group, index) || []
            : (Array.isArray(group?.members) ? group.members : []);

        return (
          <div key={String(groupKey)} className={groupClassName}>
            {label ? <div className={titleClassName}>{label}</div> : null}
            <ChatSidePanelPeopleList
              people={people}
              onSelect={onSelect}
              resolveSelectPayload={resolveSelectPayload}
              resolveRowKey={(person, personIndex) =>
                typeof resolveRowKey === 'function'
                  ? resolveRowKey(person, personIndex, group, index)
                  : person?.key || `person-${groupKey}-${personIndex}`
              }
              resolveRowProps={(person, personIndex) =>
                typeof resolveRowProps === 'function'
                  ? resolveRowProps(person, personIndex, group, index)
                  : {}
              }
              listClassName={listClassName}
            />
          </div>
        );
      })}
    </div>
  );
}
